var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"grid",staticClass:"contentGrid",class:{
    'contentGrid--tweening': _vm.isTweening
  }},_vm._l((_vm.items),function(item){return _c(`grid-${item.media.type}`,{key:item.id,ref:"items",refInFor:true,tag:"component",staticClass:"contentGrid__item",class:{
      'contentGrid__item--vic': _vm.userRole === 'vic'
    },attrs:{"content":item,"admin":_vm.admin,"file-key":'gridFile',"hoverable":""},on:{"youtube-ready":_vm.onYoutubeReady,"loaded":_vm.onLoaded}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }